<app-header></app-header>

<br />
<div
  *ngIf="isLoaderActive"
  class="row justify-content-center align-items-center loader-wrapper"
>
  <div class="col-auto">
    <div class="loader"></div>
  </div>
</div>

<main
  *ngIf="!is_dashboard_active && is_user_active && !isLoaderActive"
  class="main-content"
>
  <div class="crm mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="container-fluid">
          <div
            class="checkout wizard6 global-shadow border-0 px-sm-50 px-20 pt-sm-50 py-30 mb-30 bg-white radius-xl w-100"
          >
            <div class="row justify-content-center">
              <div class="row justify-content-center">
                <div class="col-xl-7 col-lg-8 col-sm-10">
                  <div
                    class="card checkout-shipping-form shadow-none border-0 shadow-none"
                  >
                    <div *ngIf="activeStep != 4" class="col-xl-8 mx-auto">
                      <div class="row justify-content-center">
                        <div class="alert alert-info" role="alert">
                          <div class="alert-content">
                            <p style="text-align: center">
                              <!-- Please complete this form so we can legally send
                                data deletion requests on your behalf. We can’t
                                start the process without it. -->
                              {{ "onboarding.completeForm" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-8">
                <div class="checkout-progress-indicator content-center">
                  <div class="checkout-progress">
                    <div
                      class="step"
                      id="2"
                      [ngClass]="{ active: activeStep === 2 }"
                    >
                      <span
                        ><img
                          *ngIf="activeStep !== 2"
                          class="svg"
                          src="assets/img/svg/address.svg"
                          alt="" />
                        <img
                          *ngIf="activeStep === 2"
                          class="svg"
                          src="assets/img/svg/adress-active.svg"
                          alt=""
                      /></span>
                      <span>
                        <!-- Authorization form -->
                        {{ "onboarding.step1" | translate }}
                      </span>
                    </div>
                    <div class="current">
                      <img
                        src="assets/img/svg/checkout.svg"
                        alt="img"
                        class="svg"
                      />
                    </div>
                    <div
                      class="step"
                      id="3"
                      [ngClass]="{ active: activeStep === 3 }"
                    >
                      <span
                        ><img
                          *ngIf="activeStep !== 3"
                          class="svg"
                          src="assets/img/svg/155-credit-card.svg"
                          alt=""
                        />
                        <img
                          *ngIf="activeStep === 3"
                          class="svg"
                          src="assets/img/svg/155-credit-card-active.svg"
                          alt=""
                        />
                      </span>
                      <span>
                        <!-- Sign the form -->
                        {{ "onboarding.step2" | translate }}
                      </span>
                    </div>
                    <div class="current">
                      <img
                        src="assets/img/svg/checkout.svg"
                        alt="img"
                        class="svg"
                      />
                    </div>
                    <div
                      class="step"
                      id="4"
                      [ngClass]="{ active: activeStep === 4 }"
                    >
                      <span
                        ><img
                          *ngIf="activeStep !== 4"
                          class="svg"
                          src="assets/img/svg/024-like.svg"
                          alt=""
                        />
                        <img
                          *ngIf="activeStep === 4"
                          class="svg"
                          src="assets/img/svg/024-like-active.svg"
                          alt=""
                        />
                      </span>
                      <span>
                        <!-- All set -->
                        {{ "onboarding.step3" | translate }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- checkout -->
                <div class="row justify-content-center">
                  <div
                    [ngClass]="{
                      'col-xl-7 col-lg-8 col-sm-10': activeStep !== 3
                    }"
                  >
                    <app-personal-info-form
                      (infoSubmit)="onPersonalInfoSubmitted()"
                      (signatureSubmit)="onSignatureSubmitted()"
                      (rerender)="ngOnInit()"
                    ></app-personal-info-form>
                    <!-- <app-agreement-signature></app-agreement-signature> -->
                    <!-- <div class="card checkout-shipping-form shadow-none border-0 shadow-none">
                      <div class="card-header border-bottom-0 align-content-start pb-sm-0 pb-1">
                        <h4 class="fw-500">Personal Information</h4>
                      </div>
                      <div class="card-body">
                        <div class="edit-profile__body">
                          <form>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name1">First Name</label>
                                  <input type="text" class="form-control" id="name1" placeholder="">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name1">Last Name</label>
                                  <input type="text" class="form-control" id="name2" placeholder="">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name2">Country</label>
                                  <input type="email" class="form-control" id="name2" placeholder="">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name2">State/Region</label>
                                  <input type="email" class="form-control" id="name2" placeholder="">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name2">Email Address</label>
                                  <input type="email" class="form-control" id="name2" placeholder="">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label for="name2">Phone Number</label>
                                  <input type="email" class="form-control" id="phone" placeholder="">
                                </div>
                              </div>
                            </div>
                            <div class="text-center">
                              <a href="checkout2-wizard6.html"
                                 class="btn btn-primary btn-default btn-squared text-capitalize text-white">Save &
                                Next<i class="ms-10 me-0 las la-arrow-right"></i></a>
                            </div>
                            <div>
                              <br>
                              <p>I, [NAME] ([EMAIL];[PHONE]), a resident of the [COUNTRY], hereby designate [APPNAME] as
                                my authorized agent (“Agent”) for the sole purpose of acting on my behalf in connection
                                with the exercise of my data privacy rights under applicable privacy legislation,
                                including but not limited to:</p>
                              <p>[APPNAME] may communicate directly with third-party data controllers, data brokers, and
                                other relevant entities as necessary to fulfill these requests and may provide any
                                supporting information or documentation required to authenticate or validate the
                                request.
                                I acknowledge that [APPNAME] will make commercially reasonable efforts to execute these
                                requests effectively; however, the Agent cannot guarantee the compliance or cooperation
                                of third-party data recipients, and the outcomes of such requests may be influenced by
                                factors beyond the Agent’s control.
                                This authorization shall remain in effect for the duration of my active subscription to
                                [APPNAME]'s services and shall automatically terminate upon the termination or
                                expiration of said subscription. I retain the right to revoke this authorization at any
                                time, with written notice to [APPNAME].
                              </p>
                            </div>

                            <div>
                              <br>
                              <div>
                                <canvas #canvas style="width: 100%; height: 200px; border: 1px solid #000;"></canvas>
                              </div>
                              <div class="text-center">
                                <span class="d-inline-block" style="padding: 10px">
                                  <button (click)="clearSignature()" class="btn btn-primary">Clear</button>
                                </span>
                                <span class="d-inline-block" style="padding: 10px">
                                  <button (click)="saveSignature()" class="btn btn-primary">Save</button>
                                </span>
                              </div>
                              <br>

                            </div>

                          </form>
                        </div>
                      </div>
                    </div>ends: card -->
                  </div>
                  <!-- ends: col -->
                </div>
              </div>
              <!-- ends: col -->
            </div>
          </div>
          <!-- End: .global-shadow-->
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="is_livechat_visible">
    <app-livechat-widget></app-livechat-widget>
    <noscript>
      <a href="https://www.livechat.com/chat-with/10826272/" rel="nofollow"
        >Chat with us</a
      >, powered by
      <a
        href="https://www.livechat.com/?welcome"
        rel="noopener nofollow"
        target="_blank"
        >LiveChat</a
      >
    </noscript>
  </div>
</main>

<div *ngIf="!is_user_active && !isLoaderActive" class="custom-wrapper">
  <h2 class="text-center">
    <!-- Your Subscription is Inactive -->
    {{ "onboarding.subscriptionInactive" | translate }}
  </h2>
  <p
    class="highlight text-center"
    [innerHTML]="
      'onboarding.subscriptionInactiveText'
        | translate : { name: customer_name, email: customer_email }
    "
  >
    <!-- The subscription for <strong>{{ customer_name }}</strong> ({{
    customer_email
    }}) is currently inactive. As a result, we are unable to contact data
    brokers on your behalf. -->
  </p>
  <p class="text-center">
    <!-- Please renew your subscription to continue using Removia’s services and
    protect your data privacy. -->
    {{ "onboarding.renewSubscription" | translate }}
  </p>
  <p class="text-center text-muted">
    <!-- If you have any questions, feel free to reach out to us at -->
    {{ "onboarding.contactSupport" | translate }}
    <a href="mailto:support@removia.io">support@removia.io</a>.
  </p>
</div>

<app-dashboard
  *ngIf="
    is_dashboard_active && is_user_active && dashboard_email && !isLoaderActive
  "
  [dashboard_email]="dashboard_email"
  (rerender)="ngOnInit()"
></app-dashboard>

<app-footer></app-footer>
